
var has_runOnDocumentReady_ran = false;

function runOnDocumentReady($) {
	if( has_runOnDocumentReady_ran ) {
		return;
	}
	has_runOnDocumentReady_ran = true;

	$ = jQuery;


	function animateOnScroll(nCurrentScroll) {
		$('.animate-on-scroll:not(.show)').each(function() {
			var oElement = $(this),
				nElementOffset = oElement.offset().top;

			if( nElementOffset <= nCurrentScroll ) {
				oElement.addClass('show');
			}
		})
	}

	function animateChildrenOnScroll(nCurrentScroll) {
		$('.animate-children-on-scroll:not(.show)').each(function() {
			var oElement = $(this),
				nElementOffset = oElement.offset().top;
				
			if( nElementOffset <= nCurrentScroll ) {
				oElement.addClass('show');
				oElement.find('.child').each(function(i) {
					var nDelay = ( i * 500 );
					$(this).delay(nDelay).queue(function() { 
						$(this).addClass('show').dequeue(); } 
					);
				})
			}
		})
	}

	if( $('body').hasClass('template-index') ) { 
		
		$('#site_alert, #site-header').delay(500).fadeTo(1000, 1, function() {
			$('#homepage--featured').delay(500).fadeTo(1000, 1, function() {
				nCurrentScroll = $(document).scrollTop() + (nWindowHeight * .9);

				animateOnScroll(nCurrentScroll);
				animateChildrenOnScroll(nCurrentScroll);
			})
		})
	

		var nWindowHeight = $(window).outerHeight(),
			nAnimationThreshold = nWindowHeight * .75,
			nCurrentScroll = 0,
			oScrollElements = new Array();


		$(window).scroll(function() {

			nCurrentScroll = $(document).scrollTop() + nAnimationThreshold;

			animateOnScroll(nCurrentScroll);
			animateChildrenOnScroll(nCurrentScroll);
		})
	}

	$('#home__jumbotron').carousel({
		interval: 5000
	})

	function initOwlCarousel() {
		$('.home__collection--featured').find('.product-list').owlCarousel({
		    loop:true,
		    nav:true,
		    pagination: false,
		    center: false,
		    navText: [ '<span class="icon-angle-left"></span>', '<span class="icon-angle-right"></span>' ],
		    responsive:{
		        0:{
		            items:2,
		            loop: true,
		            mouseDrag: true,
		            touchDrag: true,
		            pullDrag: true
		        },
		        481:{
		            items:3,
		            loop: false,
		            nav: false,
		            mouseDrag: false,
		            touchDrag: false,
		            pullDrag: false
		        },
		        768:{
		            items:2,
		            loop: true,
		            nav: true,
		            mouseDrag: true,
		            touchDrag: true,
		            pullDrag: true
		        },
		        1200:{
		            items:3,
		            loop: false,
		            nav: false,
		            mouseDrag: false,
		            touchDrag: false,
		            pullDrag: false
		        }
		    }
		});

		$('.home__newProducts').find('.product-list').owlCarousel({
		    loop:true,
		    nav:true,
		    pagination: false,
		    center: false,
		    navText: [ '<span class="icon-angle-left"></span>', '<span class="icon-angle-right"></span>' ],
		    responsive:{
		        0:{
		            items:2
		        },
		        481:{
		            items:3
		        },
		        768:{
		            items:4
		        },
		        1024: {
		        	items:5,
		            loop: false,
		            nav:false
		        }
		    }
		});
	}

	initOwlCarousel();
}


jQuery(document).ready(runOnDocumentReady);
jQuery(window).load(runOnDocumentReady);

